<table class="table table-striped">
    <tr><td>Date Created</td><td>{{subTopic.datecreated}}</td></tr>
    <tr><td>Last Updated</td><td>{{subTopic.lastupdated}}</td></tr>
    <tr><td>Name</td><td>{{subTopic.name}}</td></tr>
    <tr><td>Description</td><td>{{subTopic.description}}</td></tr>
    <tr><td>Code</td><td>{{subTopic.subtopiccode}}</td></tr>
    <tr><td>Is Open</td><td>{{subTopic.is_open}}</td></tr>
</table>
<form  [formGroup]="searchTemplateForm" *ngIf="server_subtopic_id!=0" >  
    <div class="row">
              <div class="col-sm-4" > Search Concept</div>
              <div class="col-sm-4" >
                  <input   formControlName="searchInput" class="form-control"/>
              </div>  
       </div>
  
       <ul>
          <li *ngFor="let conceptItem of conceptList;" style="list-style: none;">
             <button (click)="addConcept(conceptItem.id)" class="mt-1"> Add Concept</button> {{conceptItem.text}}
          </li>
  
       </ul>

       <div class="alert alert-info text-center" *ngIf="isSearching() && conceptList.length==0">
        No Results found

       </div>
